//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GetItemName, GetItemSkinName } from "@/tool";
export default {
  name: "BoxLotteryH",
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    lotteryCount: {
      type: Number,
      default: Number,
    },
    isTransition: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      run_status: 0,
      virtual_case_awards: [],
      animation_end: false,
    };
  },
  filters: {
    GetItemName,
    GetItemSkinName,
  },  
  computed: {},
  beforeDestory() {},
  created() {
    for (var i = 0; i < 5; i++) {
      this.virtual_case_awards.push(this.random_case_awards());
    }
  },
  mounted() {},
  watch: {
    lotteryCount(e) {
      this.animation_end = false;
    },
  },
  methods: {
    /** 乱序奖品池 */
    random_case_awards() {
      // 生成一轮奖品
      var generate_round_awards = () =>
        Array(20)
          .fill(null)
          .map(() => this.items[parseInt(Math.random() * this.items.length)]);

      return generate_round_awards();
    },
    reset() {
      this.virtual_case_awards = [];
      for (var i = 0; i < 5; i++) {
        this.virtual_case_awards.push(this.random_case_awards());
      }

      for (var i = 0; i < this.$props.lotteryCount; i++) {
        this.$refs.scroll[i].style.transition = "none";
        this.$refs.scroll[i].style.marginTop = `0px`;
      }

      this.animation_end = false;
      this.run_status = 0;
    },
    async start(lotteryitems) {
      this.reset();

      var award_hit_line = this.$refs.hitline;

      for (var i = 0; i < this.$props.lotteryCount; i++) {
        await this.$nextTick();
        this.$set(this.virtual_case_awards[i], 15, lotteryitems[i]); //设置开奖结果
        await this.$nextTick();

        var main_roll = this.$refs.scroll[i];
        var award_opened = this.$refs[`roll_item_${i}_15`][0];

        // console.log(award_opened);

        var move_pixel =
          award_opened.getBoundingClientRect().top -
          award_hit_line.getBoundingClientRect().top - award_hit_line.getBoundingClientRect().height/2;
        var innerHeight =  award_opened.getBoundingClientRect().height * 0.9;
        move_pixel += Math.ceil( innerHeight * Math.random());

        var addtime = (3500 + i*500) / 1000; 

        main_roll.style.transition = this.$props.isTransition
          ? "all " + addtime+ "s cubic-bezier(.17,.67,.43,1)"
          : "none";
        main_roll.style.marginTop = `${-move_pixel}px`;
      }

      setTimeout(
        () => {
          this.animation_end = true;
          this.$emit("on_finished");
        },
        this.$props.isTransition ? 6500 : 100
      );
    },
  },
};
